import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { isAuthenticated } from "./utils/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MyRequests from "./pages/MyRequests";
import MyApprovals from "./pages/MyApprovals";
import History from "./pages/History";
import PTWForm from "./pages/PTWForm";
import PTWDetail from "./pages/PTWDetail";
import AdminDashboard from "./pages/AdminDashboard";

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-dashboard"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/my-requests"
            element={
              <PrivateRoute>
                <MyRequests />
              </PrivateRoute>
            }
          />
          <Route
            path="/my-approvals"
            element={
              <PrivateRoute>
                <MyApprovals />
              </PrivateRoute>
            }
          />
          <Route
            path="/history"
            element={
              <PrivateRoute>
                <History />
              </PrivateRoute>
            }
          />
          <Route
            path="/ptw/new"
            element={
              <PrivateRoute>
                <PTWForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/ptw/create"
            element={
              <PrivateRoute>
                <PTWForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/ptw/edit/:id"
            element={
              <PrivateRoute>
                <PTWForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/ptw/:id/high-risk-forms"
            element={
              <PrivateRoute>
                <PTWForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/ptw/:id/closing"
            element={
              <PrivateRoute>
                <PTWForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/ptw/:id"
            element={
              <PrivateRoute>
                <PTWDetail />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
